'use client'

import React from 'react'
import { Checkbox as CheckboxPrimitive } from 'radix-ui'
import { cn } from '@/utils'
import Check from '@/icons/Check'

export type CheckboxProps = React.ComponentPropsWithRef<
  typeof CheckboxPrimitive.Root
>

export const Checkbox = ({ className, ...props }: CheckboxProps) => {
  return (
    <CheckboxPrimitive.Root
      className={cn(
        'data-[state=checked]:border-support-200 data-[state=checked]:bg-support-200 peer size-6 shrink-0 rounded border-2 border-black bg-white disabled:cursor-not-allowed disabled:border-gray-400 disabled:text-gray-300 data-[state=checked]:text-white data-[state=checked]:disabled:border-gray-300 data-[state=checked]:disabled:bg-gray-300',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn('flex items-center justify-center text-current')}
      >
        <Check className="size-2.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

Checkbox.displayName = CheckboxPrimitive.Root.displayName
